import { forwardRef } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import { SnackbarContent, Container, MessageContainer, Title, Content, StyledIcon, Left } from './Snackbar.Styles';

type Variant = 'info' | 'success' | 'warning' | 'error';

interface SnackbarProps {
  snackKey: string | number;
  title?: string;
  content: string;
  variant: Variant;
  closeSnackbar: (key: string | number) => void;
}

const getIcon = (variant: Variant) => {
  switch (variant) {
    case 'info':
      return <InfoIcon />;
    case 'success':
      return <CheckCircleIcon />;
    case 'warning':
      return <WarningIcon />;
    case 'error':
      return <ErrorIcon />;
    default:
      return '';
  }
};

const Snackbar = forwardRef<HTMLDivElement, SnackbarProps>(({ snackKey, title, content, variant, closeSnackbar }, ref) => {
  const handleCloseSnackbar = () => {
    closeSnackbar(snackKey);
  };

  return (
    <SnackbarContent variant={variant} ref={ref}>
      <Container>
        <Left>
          <StyledIcon variant={variant}>{getIcon(variant)}</StyledIcon>
          <MessageContainer>
            <Title>{title}</Title>
            <Content>{content}</Content>
          </MessageContainer>
        </Left>
        <IconButton aria-label="close" onClick={handleCloseSnackbar}>
          <CloseIcon />
        </IconButton>
      </Container>
    </SnackbarContent>
  );
});


export default Snackbar;